import { ISection } from '../../@customTypes/generated/contentful'
import styles from './Home.module.css'
interface ComponentProps {
  sections?: ISection[] | null | undefined
}

function Home({ sections }: ComponentProps) {
  return (
    <div className={styles.home}>
      {sections &&
        sections
          .sort((a: ISection, b: ISection) => {
            const aParts = a.fields.slug.split('-')
            const bParts = b.fields.slug.split('-')
            const textA = parseFloat(`${aParts[1]}.${aParts[3]}`)
            const textB = parseFloat(`${bParts[1]}.${bParts[3]}`)
            return textA < textB ? -1 : textA > textB ? 1 : 0
          })
          .map((section, index) => (
            <div key={index} className={styles.row}>
              <div>{section.fields.slug}</div>
              <a
                href={`${process.env.PUBLIC_URL}/${section.fields.slug}/index.html`}
              >
                {section.fields.title}
              </a>
            </div>
          ))}
    </div>
  )
}

export default Home
